<!-- Content Header (Page header) -->
<section class="content-header">
  <div class="container-fluid">
      <div class="row mb-2">
          <div class="col-sm-6">
              <h1>Diller</h1>
          </div>
          <div class="col-sm-6">
              <ol class="breadcrumb float-sm-right">
                  <li class="breadcrumb-item"><a href="/admin">Ana Sayfa</a></li>
                  <li class="breadcrumb-item active">Kurslar</li>
              </ol>
          </div>
      </div>
  </div>
  <!-- /.container-fluid -->
</section>

<!-- Main content -->
<section class="content">
  <!-- Default box -->
  <div class="container-fluid">
      <div class="card">
          <div class="card-header">
              <h3 class="card-title">Kurs Listesi <button class="btn btn-primary pull-right" (click)="openSaveModal()">+Yeni Ekle</button></h3>

             
          </div>
          <div class="card-body">
            


            
                               
                                <table class="table table-bordered">
                                  <thead>
                                  <tr>
                
                                    <th>Öğrenilecek Dil</th>
                                    <th>Ana Dil</th>
                                   
                                    <th>İşlemler</th>
                                  </tr>
                                  </thead>  
                                  <tbody>
                                    <tr *ngFor="let lang of languages" >
                                     
                                  
                                      <td>{{lang.from.name}}</td>
                                      <td>{{lang.to.name}}</td>
                                  
                                  
                                      <td> 
                                         <button class="btn btn-icon btn-pure success" (click)="detail(lang.id)"><i class="fa fa-info"></i> </button>
                                         |  
                                         <button class="btn btn-icon btn-pure danger" (click)="delete(lang.id)"><i class="fa fa-trash"></i></button></td>
                                  
                                    </tr>
                                  </tbody>
                                
                                </table>
                            



          </div>
          <!-- /.card-body -->
          <div class="card-footer"></div>
          <!-- /.card-footer-->
      </div>
  </div>
  <!-- /.card -->
</section>
<!-- /.content -->
